import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pt-3 text-sm font-medium text-danger-800 leading-4"
}
const _hoisted_2 = {
  key: 1,
  class: "pt-3 text-sm font-regular text-gray-600 leading-4"
}

import { withDefaults } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    description: { default: '' },
    error: { default: '' },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.error && !__props.loading)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.error), 1))
    : (__props.description && !__props.loading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.description), 1))
      : _createCommentVNode("", true)
}
}

})